import { Border, Title } from './ProductBranding.styles'
import type { ProductBrandingProps } from './ProductBranding.types'

export const ProductBranding = ({
  title,
  className = '',
}: ProductBrandingProps): JSX.Element => {
  return (
    <Border>
      <Title className={className}>{title}</Title>
    </Border>
  )
}
